<mat-spinner [diameter]="diameter" [color]="color"></mat-spinner>
